export const WEBAPP_GLOBAL_VISITEDPAGE = 'WEBAPP_GLOBAL_VISITEDPAGE';
export const WEBAPP_GLOBAL_OPENMODAL = 'WEBAPP_GLOBAL_OPENMODAL';
export const WEBAPP_GLOBAL_WARNINGBOX = 'WEBAPP_GLOBAL_WARNINGBOX';
export const WEBAPP_GLOBAL_UTMS = 'WEBAPP_GLOBAL_UTMS';
export const WEBAPP_CATEGORYPICKER_FOCUSEDCATEGORYSEARCH =
  'WEBAPP_CATEGORYPICKER_FOCUSEDCATEGORYSEARCH';
export const WEBAPP_GLOBAL_TRUSTPILOTCLICKEDSTAR =
  'WEBAPP_GLOBAL_TRUSTPILOTCLICKEDSTAR';
export const WEBAPP_GLOBAL_TRUSTPILOTASKFORREVIEW =
  'WEBAPP_GLOBAL_TRUSTPILOTASKFORREVIEW';
export const WEBAPP_PAYWALL_CLICKEDOPENDELETEACCOUNTMODAL =
  'WEBAPP_PAYWALL_CLICKEDOPENDELETEACCOUNTMODAL';
export const WEBAPP_REVENUESIMULATOR_SELECTEDMONTHLYINVOICEVALUE =
  'WEBAPP_REVENUESIMULATOR_SELECTEDMONTHLYINVOICEVALUE';
export const WEB_MENU_CLICKEDKNOWLEDGECENTER =
  'WEB_MENU_CLICKEDKNOWLEDGECENTER';
export const WEB_MENU_CLICKEDSUPPORT = 'WEB_MENU_CLICKEDSUPPORT';
export const WEBAPP_CATEGORYPICKER_CHOOSESEAERCHEDCATEGORY =
  'WEBAPP_CATEGORYPICKER_CHOOSESEAERCHEDCATEGORY';
export const WEBAPP_GLOBAL_CLICKEDPEPPOLFROMSIDEBAR =
  'WEBAPP_GLOBAL_CLICKEDPEPPOLFROMSIDEBAR';
export const WEBAPP_PAYWALLMODAL_OPENED = 'WEBAPP_PAYWALLMODAL_OPENED';
export const WEBAPP_SUBSCRIPTIONS_CANCELLATION_REASONS_SUBMITTED =
  'WEBAPP_SUBSCRIPTIONS_CANCELLATION_REASONS_SUBMITTED';
export const WEBAPP_SUBSCRIPTIONS_MISSING_FEATURES_SURVEY_SUBMITTED =
  'WEBAPP_SUBSCRIPTIONS_MISSING_FEATURES_SURVEY_SUBMITTED';
